import { useMutation } from "@tanstack/react-query";
import { useUserContext } from "../useUserContext";
import { createSupportTicket } from "@/app/_firebase/support";
import { NewSupportTicketInput, SupportTicket } from "@/app/@types/support";
import { sendSupportEmail } from "./useSendSupportEmail";

const useCreateSupportTicket = () => {
  const user = useUserContext();

  return useMutation<SupportTicket, Error, NewSupportTicketInput>({
    mutationFn: (input) =>
      createSupportTicket({
        userId: user.uid,
        userName: user.settings.name,
        userEmail: user.email,
        createdBy: {
          uid: user.details?.uid ?? user.uid,
          fullName: user.details?.fullName ?? user.settings.name,
        },
        input,
      }),
    onSuccess: (ticket) => {
      sendSupportEmail({ kind: "new_ticket", ticket });
    },
  });
};

export default useCreateSupportTicket;
